// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import { useEffect } from "react";

// react-router-dom components

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKTypography from "../../components/MKTypography";

import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
// Image

const LivePasswordValidation = (props) => {
  const { old_hash, hash, confirm_new_hash } = props;

  const uppercaseAlphabetRegex = new RegExp("[A-Z]");
  const lowercaseAlphabetRegex = new RegExp("[a-z]");
  const numericalRegex = /\d/;
  const specialCharacterRegex = new RegExp("[-+_!@#$%^&*.,?]");
  return (
    <Grid
      container
      justifyContent={"flex-start"}
      spacing={2}
      mt={1}
      mb={5}
      px={3}
      sx={({ breakpoints }) => ({
        [breakpoints.down("md")]: {
          px: 0,
        },
      })}
    >
      <Grid item xs={12} md={12}>
        {hash.length > 11 ? (
          <MKTypography variant="body2" fontWeight="medium" color="success">
            <DoneIcon sx={{ verticalAlign: "middle" }} /> Password is at least
            12 characters
          </MKTypography>
        ) : (
          <MKTypography variant="body2" fontWeight="medium" color="error">
            <CloseIcon sx={{ verticalAlign: "middle" }} /> Password is at least
            12 characters
          </MKTypography>
        )}
        {uppercaseAlphabetRegex.test(hash) ? (
          <MKTypography variant="body2" fontWeight="medium" color="success">
            <DoneIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 uppercase letter
          </MKTypography>
        ) : (
          <MKTypography variant="body2" fontWeight="medium" color="error">
            <CloseIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 uppercase letter
          </MKTypography>
        )}
        {lowercaseAlphabetRegex.test(hash) ? (
          <MKTypography variant="body2" fontWeight="medium" color="success">
            <DoneIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 lowercase letter
          </MKTypography>
        ) : (
          <MKTypography variant="body2" fontWeight="medium" color="error">
            <CloseIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 lowercase letter
          </MKTypography>
        )}
        {numericalRegex.test(hash) ? (
          <MKTypography variant="body2" fontWeight="medium" color="success">
            <DoneIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 number
          </MKTypography>
        ) : (
          <MKTypography variant="body2" fontWeight="medium" color="error">
            <CloseIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 number
          </MKTypography>
        )}
        {specialCharacterRegex.test(hash) ? (
          <MKTypography variant="body2" fontWeight="medium" color="success">
            <DoneIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 special character
          </MKTypography>
        ) : (
          <MKTypography variant="body2" fontWeight="medium" color="error">
            <CloseIcon sx={{ verticalAlign: "middle" }} /> Password contains at
            least 1 special character
          </MKTypography>
        )}
        {hash === confirm_new_hash && hash !== "" ? (
          <MKTypography variant="body2" fontWeight="medium" color="success">
            <DoneIcon sx={{ verticalAlign: "middle" }} /> New password and
            re-entered password matches
          </MKTypography>
        ) : (
          <MKTypography variant="body2" fontWeight="medium" color="error">
            <CloseIcon sx={{ verticalAlign: "middle" }} /> New password and
            re-entered password do not match
          </MKTypography>
        )}
        {old_hash !== undefined &&
          (old_hash === confirm_new_hash ? (
            <MKTypography variant="body2" fontWeight="medium" color="error">
              <CloseIcon sx={{ verticalAlign: "middle" }} /> Old password and
              new password matches
            </MKTypography>
          ) : (
            <MKTypography variant="body2" fontWeight="medium" color="success">
              <DoneIcon sx={{ verticalAlign: "middle" }} />
              Old password and new password do not match
            </MKTypography>
          ))}
      </Grid>
    </Grid>
  );
};

export default LivePasswordValidation;

LivePasswordValidation.defaultProps = {
  old_hash: undefined,
};

LivePasswordValidation.propTypes = {
  hash: PropTypes.string.isRequired,
  confirm_new_hash: PropTypes.string.isRequired,
};
